import { useMemo } from 'react'
import { useStores } from 'stores/utils/hooks/useStores'
import { isTenantSmava } from 'utils/url'
import { isRceEditConfig } from 'config/utils/config'
import { RCE_EDIT_PAGE_NAMES } from 'utils/pages'
import { AgeGroup } from 'constants/components'
import { useVoucherBanner } from 'components/VoucherBanner'

interface LayoutFlags {
  isDacFooterWrapperStep: boolean
  isProgressIndicatorDisplayed: boolean
  areDDFTrustCardsDisplayed: boolean
  isAgbShownAtBottomOfPage: boolean
  isDacFooterWrapperDisplayed: boolean
  isSmava: boolean
  isRCEEditPage: boolean
}

export const useLayoutFlags = (
  currentPageInSession?: string,
  configName?: string,
  ageGroup?: AgeGroup
): LayoutFlags => {
  const { navigation } = useStores()

  const isSmava = isTenantSmava()
  const { shouldShowTopActivationPromptBanner } = useVoucherBanner()

  return useMemo(() => {
    const isRCEEditPage = configName ? isRceEditConfig(configName) : false

    const isDacFooterWrapperStep =
      isRCEEditPage && currentPageInSession === 'dac'

    const isProgressIndicatorDisplayed =
      !isDacFooterWrapperStep &&
      currentPageInSession !== 'brandTracking' &&
      !RCE_EDIT_PAGE_NAMES.includes(currentPageInSession || '') &&
      !(isSmava && shouldShowTopActivationPromptBanner)

    const areDDFTrustCardsDisplayed =
      isSmava &&
      currentPageInSession !== 'dac' &&
      !RCE_EDIT_PAGE_NAMES.includes(currentPageInSession || '')

    const isAgbShownAtBottomOfPage = currentPageInSession === 'editPage'

    const isDacFooterWrapperDisplayed =
      (isDacFooterWrapperStep &&
        ageGroup !== AgeGroup.YOUNG_AGE_GROUP &&
        isSmava) ||
      isRCEEditPage

    return {
      isDacFooterWrapperStep,
      isProgressIndicatorDisplayed,
      areDDFTrustCardsDisplayed,
      isAgbShownAtBottomOfPage,
      isDacFooterWrapperDisplayed,
      isSmava,
      isRCEEditPage
    }
  }, [
    currentPageInSession,
    configName,
    navigation.currentPageInSession,
    isSmava,
    ageGroup,
    shouldShowTopActivationPromptBanner
  ])
}
